import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue, update, child } from "firebase/database";
import { getAuth, sendPasswordResetEmail as fbSendPasswordResetEmail } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID
};

export const fbApp = initializeApp(firebaseConfig)

// publish a handle to the Realtime database
const fbRtDb = getDatabase(fbApp);
const dbRefUsers = ref(fbRtDb, '/users');
const dbRefProjects = ref(fbRtDb, '/projects');
const dbRefPitches = ref(fbRtDb, '/pitches');

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(fbApp);

export { dbRefUsers, dbRefProjects, dbRefPitches, fbRtDb }
export const sendPasswordResetEmail = (email) => {
  return fbSendPasswordResetEmail(auth, email);
}

export function getUserDetails(uid) {
  return new Promise((resolve, reject) => {
    const userRef = child(dbRefUsers, uid);

    onValue(userRef, (snapshot) => {
      const userDetails = snapshot.val();
      resolve(userDetails);
    }, (error) => {
      reject(error);
    });
  });
}

export function addMemberToProject(projectTitle, member) {
  return new Promise((resolve, reject) => {
    onValue(dbRefProjects, (snapshot) => {
      const data = snapshot.val();
      const projects = Object.values(data);
      const project = projects.find((project) => project.title === projectTitle);

      if (project) {
        const updatedMembers = [...project.members, member];
        const updatedProject = { ...project, members: updatedMembers };

        update(ref(dbRefProjects), { [project.id]: updatedProject })
          .then(() => {
            resolve(updatedProject);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        reject(new Error('Project not found'));
      }
    }, (error) => {
      reject(error);
    });
  });
}
